<template>
  <div>
    <ts-panel>
      <ts-panel-wrapper>
        <div class="tw-flex tw-justify-between">
          <div class="tw-justify-start">
            <h4 class="tw-mb-0">{{ $t("user.branch") }}</h4>
            <small class="tw-text-gray-400">{{
              $t("user.defineBranchForUser")
            }}</small>
          </div>
          <div class="tw-justify-end">
            <div class="tw-text-red-600" v-if="errors.has('branches')">
              {{ errors.first("branches") }}
            </div>
            <input
              v-model="search"
              type="text"
              class="form-control form-control-sm"
              :placeholder="$t('search')"
            />
          </div>
        </div>
        <ul
          class="
            tw-mt-2
            tw-mb-0
            tw-border
            tw-border-gray-200
            tw-rounded-lg
            tw-h-36
            tw-overflow-auto
          "
        >
          <li v-for="branch in branches" :key="branch.branch_id">
            <div class="tw-flex tw-items-center tw-justify-between">
              <ts-checkbox
                class="tw-m-1"
                @change="setBranches"
                :value="`${branch.branch_id}`"
                :checkedValue="Object.keys(model.branches)"
                >{{ branch.prefix_code }}</ts-checkbox
              >
              <a-switch
                v-tooltip="$t('user.isDefault')"
                size="small"
                v-if="
                  Object.keys(model.branches).includes(`${branch.branch_id}`)
                "
                v-model="model.branches[branch.branch_id].is_default"
                @change="(event) => setAsDefaultBranch(branch.branch_id, event)"
              >
              </a-switch>
            </div>
          </li>
        </ul>
      </ts-panel-wrapper>
    </ts-panel>
  </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { transform } from "lodash";

export default {
  name: "branch",
  props: ["value", "validate"],
  data() {
    return {
      model: {},
      errors: new Errors(),
      search: null,
    };
  },
  computed: {
    branches() {
      if (this.search) {
        return this.$store.state.auth.user.branches.filter(
          (r) =>
            r.branch_name_en.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1
        );
      }
      return this.$store.state.auth.user.branches;
    },
  },
  methods: {
    setBranches(branches) {
      this.model.branches = transform(
        branches,
        (result, branchId) => {
          result[branchId] = {
            is_default: this.model.branches[branchId]
              ? this.model.branches[branchId].is_default
              : false,
          };
        },
        {}
      );
    },
    setAsDefaultBranch(branchId, value) {
      Object.keys(this.model.branches)
        .filter((bKey) => bKey != branchId)
        .forEach((bKey) => {
          this.$set(this.model.branches[bKey], "is_default", false);
        });

      this.$set(this.model.branches[branchId], "is_default", value);
      this.$forceUpdate();
    },
  },
  created() {
    this.model = this.value;
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors);
    },
  },
};
</script>
<style scoped>
ol,
ul {
  padding-left: 2px;
}
</style>